import styled from '@emotion/styled'

export const StyledContainer = styled.div`
  background-color: #e5e5e5;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background-size: cover;

`

export const StyledSection = styled.section`
  width: 100%;
  margin-top: 100px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  
  @media (min-width: 700px) {
    left: 0;
    top: 0;
    bottom: 0;
    position: absolute;
  }
`

export const StyledLogin = styled.div`
  border: 3px solid var(--color-third);
  max-width: 1000px;
  width: calc(100% - 40px);
  margin: 0 auto;
  border-radius: 10px;
  overflow: hidden;
  color: var(--color-primary);
  box-shadow: 10px 10px 10px 10px rgb(50 79 159 / 40%);
  background-color: var(--color-hover-light-almost);

  .left, .right {
    position: relative;
    display: inline-block;
    width: 50%;
    vertical-align: top;
    height: 500px;

    @media (max-width: 700px) {
      width: 100%;
      height: auto;
    }
  }

  .left {
    border-right: 3px solid var(--color-third);

    @media (max-width: 700px) {
      border-right: none;
      border-bottom: 3px solid var(--color-third);
    }

    & > div {
      height: 500px;
      padding: 20px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      @media (max-width: 700px) {
        height: auto;
      }

      article {
        h2 {
          margin-bottom: 30px;
          text-align: center;

          i {
            margin-right: 20px;
          }
        }

        select, input {
          border: 1px solid var(--color-third);
          color: var(--color-dark);
        }

        .button.cancel {
          margin-left: 20px;
        }
      }
    }
  }
`

export const StyledImage = styled.div`
  height: 500px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 80%;
  }

  @media (max-width: 700px) {
    height: 300px;
  }
`
